import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/user-assignment/UserAssignmentAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { PersonnelUsersFilter } from "./personnel-users-filter/PersonnelUsersFilter";
import { PersonnelUsersTable } from "./personnel-users-table/PersonnelUsersTable";
import { usePersonnelUsersUIContext } from "./PersonnelUsersUIContext";

export function PersonnelUsersCard({
  history,
  userGroupId,  
  userType
}) {
  // Personnel Users Card UI Context
  const personnelUsersUIContext = usePersonnelUsersUIContext();
  const personnelUsersUIProps = useMemo(() => {
    return {
      ids: personnelUsersUIContext.ids
    };
  }, [personnelUsersUIContext]);

  // Getting curret state of UserAssignment from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );  
  const { authorities } = currentState;

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);
  
  // Personnel Users Redux state
  const dispatch = useDispatch();

  /** Belli Bir Kullanıcı Grubuna Ait Kullanıcı Listesini Kaydeder */
  const saveUsers = (ids) => {
    dispatch(actions.saveUsers(userType, userGroupId, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kullanici-ve-kullanici-gruplari/${userType}`), 2500);
  };

  const title = <>Personel Kullanıcı Listesi{personnelUsersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{personnelUsersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary ml-2"
              onClick={() => saveUsers(personnelUsersUIProps.ids)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <PersonnelUsersFilter />
        <PersonnelUsersTable />
      </CardBody>
    </Card>
  );
}